"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sourceAddressSchema = sourceAddressSchema;
const zod_1 = require("zod");
const constants_1 = require("./constants");
const ZIP_DE_LENGTH = 5;
function sourceAddressSchema({ maxCharsBusinessName, maxCharsPrivateName, maxNames, translatedStrings, }) {
    const required = translatedStrings.requiredField;
    return zod_1.z
        .object({
        business: zod_1.z.boolean().optional(),
        city: zod_1.z.string({ error: () => required }).min(1, required),
        countryCode: zod_1.z.string({ error: () => required }).min(1, required),
        lines: zod_1.z
            .array(zod_1.z.string({ error: () => required }).min(1, required))
            .min(1, required),
        streetAddress: zod_1.z.string({ error: () => required }).min(1, required),
        title: zod_1.z.string().optional(),
        zip: zod_1.z
            .string({ error: () => required })
            .min(ZIP_DE_LENGTH, translatedStrings.nCharsField(ZIP_DE_LENGTH))
            .max(ZIP_DE_LENGTH, translatedStrings.nCharsField(ZIP_DE_LENGTH)),
    })
        .superRefine((data, ctx) => {
        const maxNamesForOrder = data.business === true ? constants_1.BUSINESS_MAX_NAMES_PER_FORWARDING : maxNames;
        if (data.lines.length > maxNamesForOrder) {
            ctx.addIssue({
                code: 'too_big',
                maximum: maxNamesForOrder,
                origin: 'array',
                inclusive: true,
                message: translatedStrings.maxNamesN(maxNamesForOrder),
                path: ['lines'],
            });
        }
        const perLineLimit = data.business
            ? maxCharsBusinessName
            : maxCharsPrivateName;
        data.lines.forEach((line, index) => {
            if (line.length > perLineLimit) {
                ctx.addIssue({
                    code: 'too_big',
                    maximum: perLineLimit,
                    origin: 'string',
                    inclusive: true,
                    message: translatedStrings.maxCharsN(perLineLimit),
                    path: ['lines', index],
                });
            }
        });
    });
}
//# sourceMappingURL=source-address.js.map